<template>
	<tr>
		<td class="input-container"><input class="addCommInput form-control m-input" v-model="number" :disabled="commission" data-container="body" data-toggle="popover" data-placement="top" :data-content="tips" /></td><!-- number -->
		<!-- dau, duoi, lo -->
		<td class="input-container" v-for="(item, index) in header"><input :idx="index" class="addCommInput form-control m-input" v-model="values[index]" /></td>
		<td>
			<a href="javascript:;" @click="addAction" style="margin-right: 2px;" class="btn btn-sm btn-outline-success m-btn m-btn--icon m-btn--icon-only add-comm-btn">
				<i class="la la-check"></i>
			</a>
			<a href="javascript:;" @click="cancelAction" class="btn btn-sm btn-outline-danger m-btn m-btn--icon m-btn--icon-only add-comm-btn">
				<i class="la la-times"></i>
			</a>
		</td>
	</tr>
</template>

<script>
	import { mapGetters } from 'vuex';

	export default {
		props: ['commission', 'header', 'index', 'type', 'dataKey'],

		data() {
			return {
				number: '',
				values: [],
				originValues: [],
				tips: '*Tips: <br/> - Sử dụng dấu , để nhập nhiều số!'
			}
		},

		mounted(){
			if(this.type == 'da'){
				this.tips += '<br/> - Sử dụng dấu . để tạo cặp số!';
			}
			$('[data-toggle="popover"]').popover({
				trigger: 'focus',
				html: true
			});

			if(this.commission){
				this.number = this.commission.number;
				let vls = [...this.values];
				let orgins = [...this.values];

				for(let i=0;i<this.header.length;i++){
					if(!this.commission.comm[this.header[i].id]) continue;
					let comm = this.commission.comm[this.header[i].id][0];
					if(!comm) continue;

					vls[i] = comm[this.dataKey.user];
					orgins[i] = comm[this.dataKey.user];
				}

				this.values = vls;
				this.originValues = orgins;
			}
		},

		computed: {
			...mapGetters({
				user: 'user',
		  		gameInfo: 'gameInfo'
			})
		},

		methods: {
			addAction: function(){
				let vm = this;

        		let data = [];

        		if(this.number == ""){
        			swal("Lỗi", "Số không được bỏ trống!", "error");
					return;
        		}

        		let channel = parseInt($("#filterChannelSelection").val());
        		let channels = Object.values(this.gameInfo.channels);
        		let c = channels.filter(e => { return e.id == channel; });
        		if(c.length == 0) return;

        		let game = c[0].game_id;

        		for(let i=0;i<this.header.length;i++){
        			if(!this.values[i]) continue;
        			if(this.values[i] == this.originValues[i]) continue;

        			let d = {
	    				game: game,
	    				channel: channel,
	    				prop: this.header[i].id,
	    				number: this.number
	    			};
	    			d[this.dataKey.data] = parseFloat(this.values[i]);

        			data.push(d);
        			
        		}

        		this.$emit('number-add', {data: data, index: this.commission ? this.index : -1});
			},
			cancelAction:function(){
				this.$emit("number-cancel", this.commission ? this.index : -1);
			}
		}
	}
</script>

<style>
	.m-btn--icon.m-btn--icon-only.btn-sm.add-comm-btn{
		width: 20px;
		height: 20px;
	}
	.addCommInput {
		padding: 0.35rem .5rem;
		text-align: center;
	}
	.input-container{
		padding: 2px !important;
	}
</style>
